import * as React from 'react';
import * as cn from 'classnames';

import { Text } from '../../../../Text';
import { Bank, Developer, Ensuranse, RealEstate, Retail } from '../../../../Icons';

import { EHeaderIcons } from '../../../types/types';
import * as styles from './styles.css';

interface IProps {
  className?: string;
  title: string;
  icon: EHeaderIcons;
}

const icons = [Bank, Developer, Ensuranse, RealEstate, Retail];

export const CardHeader: React.FC<IProps> = props => {
  const Icon = icons[props.icon];

  return (
    <div className={cn(styles['header'], props.className)}>
      <Icon className={styles['icon']} />
      <Text size="h3" bold>
        {props.title}
      </Text>
    </div>
  );
};
